<template>
  <v-container id="search-delivery-location">
    <v-row>
      <v-col cols="12" lg="4" class="pr-10 pl-5 mb-9">
        <v-row class="mb-3">
            <v-radio-group dense row v-model="input.radioTownLocationInfo">
              <v-radio v-for="location in townLocationInfo"
                       :value="location.value"
                       :label="location.label" tabindex="9">
              </v-radio>
            </v-radio-group>
            <v-menu
                v-if="suburbanDeliveryFareType === 'suburban_fr_delivery_area'"
                v-model="input.showDeliveryRangeList"
                transition="scale-transition"
                nudge-bottom="30"
                allow-overflow
                max-width="500px"
                max-height="300px"
            >
              <template v-slot:activator="{on}">
                <v-text-field
                    v-on="on"
                    @click="input.showDeliveryRangeList=true"
                    :value="getAreaText(input.locationInfo.deliveryRange)"
                    :disabled="isSelectDowntown"
                    append-icon="keyboard_arrow_down"
                    dense readonly tabindex="10"
                    style="margin-top: 16px"
                >
                </v-text-field>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in sortedSuburbanAreaDeliveryFares"
                  :key="index"
                  @click="input.locationInfo.deliveryRange = item"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.area }}구간</v-list-item-title>
                    <v-list-item-subtitle>{{ item.areaDescription }}({{ item.fare }}원)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex reverse pa-0">
            <v-menu
                    v-model="input.startPoint.showList"
                    max-width="500px"
                    max-height="300px"
                    allow-overflow
                    nudge-bottom="30"
                    transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="출발지"
                  clearable dense
                  v-model="input.startPoint.searchKeyword"
                  @keyup.enter="onSetPosition(input.startPoint)"
                  @click="showDefaultList(input.startPoint)"
                  @click:clear="fieldClean(input.startPoint)"
                  tabindex="11"
                ></v-text-field>
              </template>
              <v-list v-if="!input.startPoint.isDefault">
                <v-list-item
                  v-for="(position, index) in input.startPoint.positionList"
                  @click="onSelectedPosition(position, input.startPoint)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ position.place_name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ position.address_name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item
                    v-for="(position, index) in input.startPoint.homeAddressList"
                    @click="onSelectedPosition(position, input.startPoint)"
                    dense>
                  <v-list-item-icon>
                    <v-icon v-if="index === 0" color="yellow"> mdi-star </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
                <v-divider v-if="input.startPoint.homeAddressList && input.startPoint.recentAddressList"></v-divider>
                <v-subheader v-if="input.startPoint.recentAddressList">최근 이용 내역</v-subheader>

                <v-list-item
                    v-for="(position, index) in input.startPoint.recentAddressList"
                    @click="onSelectedPosition(position, input.startPoint)"
                    dense>
                  <v-list-item-content>
                    <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" v-if="input.startPoint.addressText" class="mt-0 pt-0">
            <v-icon>done</v-icon>
            <span class="font-weight-bold">{{ this.input.startPoint.addressText }}</span>
          </v-col>
          <v-col cols="12" class="py-0 ml-3">
            <v-text-field
              prepend-inner-icon="mode_comment"
              label="출발지 추가정보"
              dense clearable outlined
              auto-grow hide-details
              v-model="input.startPoint.comment"
              tabindex="12"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row style="margin-top: 20px">
          <v-col style="margin-top: 20px" cols="12" class="d-flex reverse pa-0">
            <v-menu v-model="input.endPoint.showList"
                    max-width="500px"
                    max-height="300px"
                    allow-overflow
                    nudge-bottom="30"
                    transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="도착지"
                  clearable dense
                  v-model="input.endPoint.searchKeyword"
                  @keyup.enter="onSetPosition(input.endPoint)"
                  @click="showDefaultList(input.endPoint)"
                  @click:clear="fieldClean(input.endPoint)"
                  tabindex="13"
                ></v-text-field>
              </template>
              <v-list v-if="!input.endPoint.isDefault">
                <v-list-item
                  v-for="(position, index) in input.endPoint.positionList"
                  :key="index"
                  @click="onSelectedPosition(position, input.endPoint)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ position.place_name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ position.address_name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item
                    v-for="(position, index) in input.endPoint.homeAddressList"
                    @click="onSelectedPosition(position, input.endPoint)"
                    dense>
                  <v-list-item-icon>
                    <v-icon v-if="index === 0" color="yellow"> mdi-star </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
                <v-divider v-if="input.endPoint.homeAddressList && input.endPoint.recentAddressList"></v-divider>
                <v-subheader v-if="input.endPoint.recentAddressList">최근 이용 내역</v-subheader>

                <v-list-item
                    v-for="(position, index) in input.endPoint.recentAddressList"
                    @click="onSelectedPosition(position, input.endPoint)"
                    dense>
                  <v-list-item-content>
                    <v-list-item-title>{{  position.address_name }} {{ position.place_name ? `(${position.place_name})` : '' }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" v-if="input.endPoint.addressText" class="mt-0 pt-0">
            <v-icon>done</v-icon>
            <span class="font-weight-bold"> {{ this.input.endPoint.addressText }}</span>
          </v-col>
          <v-col cols="12" class="py-0 ml-3">
            <v-text-field
                prepend-inner-icon="mode_comment"
                label="도착지 추가정보"
                dense clearable outlined
                auto-grow hide-details
                v-model="input.endPoint.comment"
                tabindex="15"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" lg="8">
        <v-row justify="end">
        <div id="delivery-map">
          <div v-if="this.input.locationInfo && this.input.locationInfo.driveTime" id="delivery-short-info" class="white--text pa-3" >
            <div>예상 주행 시간 : {{$func.msToTimeFormat(Number(input.locationInfo.driveTime)*1000)}}</div>
            <div>예상 주행 거리 : {{ Number(input.locationInfo.distance/1000).toFixed(3)}} km</div>
            <div>배송 요금 : {{input.locationInfo.deliveryFee.toLocaleString()}} 원</div>
          </div>
        </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props:{
      deliveryDate: {
        type: String,
        default : null,
      },
      deliveryTime: {
        type: String,
        default : null,
      },
      deliveryFare: {
        type: Object,
        default: null,
      },
      locationInfoData: { //완성된 위치정보
        type:Object,
        default: undefined
      },
      customerInfo: {
        type: Object,
        default: undefined
      }
    },
    data() {
      return {
        suburbanDeliveryFareType: '',
        suburbanDeliveryFares: [],
        input:{
          deliveryRangeList: [],
          locationInfo:{
            deliveryRange: {
              configName :'',
              configValue:''
            },
            departure:'',
            departurePoint:'',
            departureComment:'',
            destination:'',
            destinationPoint:'',
            destinationComment:'',
            distance:0,
            driveTime:0,
            deliveryFee:0,
          },
          startPoint: {
            name:'',
            searchKeyword: '',
            positionList: null,
            isDefault:false,
            homeAddressList: null,
            recentAddressList: null,
            showList: false,
            marker: undefined,
            addressText: null,
            selectedPosition: {},
            comment:'',
          },
          endPoint: {
            name:'',
            searchKeyword: '',
            positionList: null,
            isDefault:false,
            homeAddressList: null,
            recentAddressList: null,
            showList: false,
            marker: undefined,
            addressText: null,
            selectedPosition:{},
            comment:'',
          },
          mapInfo: {
            map: null,
            mapOptions: {
              lat:null,
              lng:null,
            },
            zoom:0,
            initLayers: [],
            naverMapBound: {north:null, south:null, west: null, east: null},
            initFitBound: true,
          },
          drivePathInfo: {
            routesInfo: {
              searchOption: '',
              trafficInfo: '',
              predictionType: 'departure',
              departure:'',
              destination:'',
              predictionTime:''
            }
          },
          drivingPath:null,
          radioTownLocationInfo:'',
          showDeliveryRangeList:false
        },
        default:{
          deliveryRangeList: this.$store.state.config.suburban.filter(item => item.configValue !== '0suburban'),
          locationInfo:{
            deliveryRange:this.$store.state.config.suburban[1],
            distance:0,
            driveTime:0,
            deliveryFee:0,
          },
          startPoint: {
            name:'departure',
          },
          endPoint: {
            name:'destination',
          },
          mapInfo: {
            map: null,
            mapOptions: {
              lat:null,
              lng:null,
            },
            zoom:13,
            initLayers: ['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT'],
            naverMapBound: {north:null, south:null, west: null, east: null},
            initFitBound: true,
          },
          drivePathInfo: {
            routesInfo: {
              searchOption: "00",
              trafficInfo: "Y",
              predictionType: "departure",
            }
          },
          radioTownLocationInfo:'downTown',
          showDeliveryRangeList:false
        },
        townLocationInfo : [
          {label:'시내', value:'downTown'},
          {label:'시외', value:'suburbs'},
        ],
      }
    },
    async mounted(){
      await this.initData();
      await this.initMapObject();

      // center info
      const centerId = this.$store.state.centerInfo.centerId;
      const { data:fareData } = await this.$api.getCenterInfoById(centerId);
      this.suburbanDeliveryFareType = fareData.suburbanDeliveryFareType.configValue;

      // 시외 구간 요금제로 설정되어있는 경우
      if (this.suburbanDeliveryFareType.includes('area')) {
        const { data:suburbanAreaFares } = await this.$api.getSuburbanAreaFares(centerId, this.suburbanDeliveryFareType);
        this.suburbanDeliveryFares = suburbanAreaFares;

        this.input.locationInfo.deliveryRange = this.sortedSuburbanAreaDeliveryFares[0];
      }
    },
    watch:{
      deliveryDate() {
        this.reqDrivingPath();
      },
      deliveryTime(){
        this.reqDrivingPath();
      },
      'input.locationInfo.deliveryRange'() {
        this.reqDrivingPath();
      },
      'input.radioTownLocationInfo'() {
        this.reqDrivingPath();
      },
      'input.startPoint.comment'() {
        this.sendLocationInfoToParent();
      },
      'input.endPoint.comment'() {
        this.sendLocationInfoToParent();
      },
      'input.startPoint.searchKeyword'(val) {
        if(val == null || val === '') {
          this.input.startPoint.showList = false;
          this.input.startPoint.isDefault = false;
          this.input.startPoint.addressText = null;
          this.input.startPoint.selectedPosition = {};
          if (this.input.startPoint.marker && this.input.startPoint.marker.setMap) {
            this.input.startPoint.marker.setMap(null);
          }
        }
      },
      'input.endPoint.searchKeyword'(val) {
        if(val == null || val === '') {
          this.input.endPoint.showList = false;
          this.input.endPoint.isDefault = false;
          this.input.endPoint.addressText = null;
          this.input.endPoint.selectedPosition = {};
          if (this.input.endPoint.marker && this.input.endPoint.marker.setMap) {
            this.input.endPoint.marker.setMap(null);
          }
        }
      },
    },
    computed: {
      isSelectDowntown() {
        return this.input.radioTownLocationInfo === 'downTown'
      },
      sortedSuburbanAreaDeliveryFares() {
        return this.suburbanDeliveryFares.sort((f1, f2) => f1.area - f2.area);
      }
    },
    methods: {
      getAreaText(info) {
        return (!!info) ? `${info.area}구간 - ${info.areaDescription}(${info.fare}원)` : '';
      },
      initData() {
        this.input = this.$func.initObjectData(this.input, this.default);
      },
      async initMapObject() {
        let mapData = {};

        if(this.$store.state.userInfo.centerPoint!== null) {
          let centerPoint = this.$store.state.userInfo.centerPoint;

          let commaIdx =  centerPoint.indexOf(',');
          mapData['lng'] = parseFloat(centerPoint.substring(0, commaIdx));
          mapData['lat'] = parseFloat(centerPoint.substring(commaIdx + 1, centerPoint.length ));
        }
        else {
          mapData['lat'] = 37.523706;
          mapData['lng'] = 126.925468;
        }

        this.input.mapInfo.mapOptions = mapData;

        // create naver map object
        this.input.mapInfo.map = new naver.maps.Map("delivery-map", {
          zoom: this.input.mapInfo.zoom,
          maxZoom: 21,
          minZoom: 0,
          center: new naver.maps.LatLng(this.input.mapInfo.mapOptions.lat, this.input.mapInfo.mapOptions.lng),
          zoomControlOptions: {position: naver.maps.Position.RIGHT_CENTER},
          zoomControl: true,
        });
      },
      showSuburbanValue(name) {
        if(name === '') {
          return;
        }
        const suburban = name.split('|');
        return suburban[0]+'-'+suburban[1]+'('+suburban[2]+')'
      },
      getSelectedSuburbanText(text, idx) {
        return text && (text.indexOf('|') > -1) ? text.split('|')[idx] : '';
      },
      async searchCustomerAddress(addressKeyword) {
        return await new Promise(res => {
          const geocoder = new kakao.maps.services.Geocoder();
          geocoder.addressSearch(addressKeyword, (geoResult, geoStatus) => {
            // 결과값 존재 시 [0] 번째 값만 추가
            if (geoStatus === kakao.maps.services.Status.OK) {
              // {address_name, place_name, x, y}
              res({
                address_name: geoResult[0].address_name,
                place_name: addressKeyword,
                x: geoResult[0].x,
                y: geoResult[0].y
              });
            } else {
              res(null)
            }
          })
        })
      },
      async onSetPosition(bind) {
        if(bind.showList) {
          bind.showList = false;
        }

        // 주소-좌표 변환 객체 생성
        const geocoder = new kakao.maps.services.Geocoder();
        // 주소로 좌표 검색
        await geocoder.addressSearch(bind.searchKeyword, (geoResult, geoStatus) => {
          const result = [];
          // 결과값 존재 시 [0] 번째 값만 추가
          if(geoStatus === kakao.maps.services.Status.OK) {
            // {address_name, place_name, x, y}
            result.push({
              address_name: geoResult[0].address_name,
              place_name: bind.searchKeyword,
              x: geoResult[0].x,
              y: geoResult[0].y
            });
          }

          let lat = null;
          let lng = null;
          const userInfo = this.$store.state.userInfo.garagePoint;
          if(userInfo.length > 0) {
            lat = userInfo.split(',')[1];
            lng = userInfo.split(',')[0];
          }

          //장소 검색 객체 생성
          const ps = new kakao.maps.services.Places();
          //키워드로 장소 검색
          // CenterPoint 기준으로 리스트 출력
          ps.keywordSearch(bind.searchKeyword, (data, searchStatus, pagination) => {

              // 주소좌표, 키워드 장소 둘다 결과 값이 없을 경우
              if(geoStatus !== kakao.maps.services.Status.OK && searchStatus !== kakao.maps.services.Status.OK) {
                this.$store.commit('snackbar', {timeout : 2000, msg: '결과가 존재하지 않습니다.'});
              }
              // 결과값이 하나라도 존재 할 경우 menu list 출력
              else {
                bind.positionList = [...result, ...data];
                bind.showList = true;
                bind.isDefault = false;
              }
            },
            {
              x: lng, //longitude
              y: lat //latitude
            });
        });
      },
      onSelectedPosition(position, bind) {
        const {x, y, address_name, place_name} = position;
        bind.selectedPosition = position;
        bind.searchKeyword = place_name;
        bind.addressText =place_name+'('+address_name+')';

        if (this.input.mapInfo.map) {
          this.input.mapInfo.mapOptions.lat = y;
          this.input.mapInfo.mapOptions.lng = x;
          this.input.mapInfo.map.setCenter({y, _lat: y, x, _lng: x});
          this.input.mapInfo.map.setZoom(13, false);
        }
        if(bind.marker && bind.marker.setMap) {
          bind.marker.setMap(null);
        }
        bind.marker = this.createMarker(y, x);
        //drivingPath 요청
        const selectedStartPointNotEmpty = Object.keys(this.input.startPoint.selectedPosition).length > 0;
        const selectedEndPointNotEmpty = Object.keys(this.input.endPoint.selectedPosition).length > 0;
        if(selectedStartPointNotEmpty || selectedEndPointNotEmpty) {
          this.reqDrivingPath();
        }
      },
      async reqDrivingPath() {
        try {
          const selectedStartPointNotEmpty = Object.keys(this.input.startPoint.selectedPosition).length > 0;
          const selectedEndPointNotEmpty = Object.keys(this.input.endPoint.selectedPosition).length > 0;
          if(!selectedStartPointNotEmpty || !selectedEndPointNotEmpty) {
            return;
          }

          let departure = {
            name: "departure",
            lon: this.input.startPoint.selectedPosition.x,
            lat: this.input.startPoint.selectedPosition.y
          };
          let destination = {
            name: "destination",
            lon: this.input.endPoint.selectedPosition.x,
            lat: this.input.endPoint.selectedPosition.y
          };

          this.input.drivePathInfo.routesInfo['departure'] = departure;
          this.input.drivePathInfo.routesInfo['destination'] = destination;
          this.input.drivePathInfo.routesInfo['predictionTime'] = this.deliveryDate+'T'+this.deliveryTime+':00'+'+0900';

          const fareType = this.input.radioTownLocationInfo === 'downTown' ? 'fr_delivery' : this.suburbanDeliveryFareType;
          const suburbanArea = fareType === 'suburban_fr_delivery_area' ? this.input.locationInfo.deliveryRange.area : '';

          this.deliveryFare.type = fareType;
          this.deliveryFare.detail = fareType === 'suburban_fr_delivery_area' ? `${ this.input.locationInfo.deliveryRange.area }구간 - ${ this.input.locationInfo.deliveryRange.areaDescription }` : '';

          const request= {
            mapInfoJson: JSON.stringify(this.input.drivePathInfo),
            fareType : fareType,
            suburbanArea: suburbanArea
          }
          const res = await this.$api.deliveryDrivingInfo(request);
          const summary = res.data.features[0].properties;
          const path = res.data.features;
          this.input.locationInfo.driveTime = summary['totalTime'];
          this.input.locationInfo.distance = summary['totalDistance'];
          this.input.locationInfo.deliveryFee = summary['totalFee'];
          this.drawDrivingPath(path);
          this.sendLocationInfoToParent();
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDrivingPath'});
        }
      },
      createMarker(lat,lng) {
        return new naver.maps.Marker({
          position: new naver.maps.LatLng(lat, lng),
          map: this.input.mapInfo.map,
        });
      },
      drawDrivingPath(path) {
        let path1 = path.filter(item => item.geometry.coordinates.length !== 2);
        path1 = path1.map(item => item.geometry.coordinates);
        path1 = path1.map(item => item.map(item => ({lat: item[1], lng: item[0]})));
        let pathList = [];
        path1.map(item => item.map(item => pathList.push(item)));

        if(this.input.drivingPath && this.input.drivingPath.setMap) {
          this.input.drivingPath.setMap(null);
        }

        this.input.drivingPath = new naver.maps.Polyline({
          map : this.input.mapInfo.map,
          path : pathList,
          clickable: true,
          strokeColor: '#0096e0',
          strokeStyle: 'solid',
          strokeWeight: 3,
          strokeLineCap:'round',
          strokeLineJoin:'round'
        });
      },
      sendLocationInfoToParent() {
        this.input.locationInfo.departure=this.input.startPoint.addressText;
        this.input.locationInfo.departureComment = this.input.startPoint.comment;
        this.input.locationInfo.departurePoint = this.input.startPoint.selectedPosition.x + ','+this.input.startPoint.selectedPosition.y;

        this.input.locationInfo.destination=this.input.endPoint.addressText;
        this.input.locationInfo.destinationComment = this.input.endPoint.comment;
        this.input.locationInfo.destinationPoint = this.input.endPoint.selectedPosition.x + ','+this.input.endPoint.selectedPosition.y;

        const suburban = this.input.radioTownLocationInfo === 'downTown' ? {configName:"0구간|시내|0원", configValue:"0suburban"} : {configName:"1구간|김해, 양산|10,000원", configValue:"1suburban"}; // TODO: 추후 삭제대상
        this.locationInfoData = {
          deliveryFee : this.input.locationInfo.deliveryFee,
          deliveryRange : suburban,
          departure:this.input.startPoint.addressText,
          departureComment : this.input.startPoint.comment,
          departurePoint : this.input.startPoint.selectedPosition.x + ','+this.input.startPoint.selectedPosition.y,
          destination:this.input.endPoint.addressText,
          destinationComment: this.input.endPoint.comment,
          destinationPoint : this.input.endPoint.selectedPosition.x + ','+this.input.endPoint.selectedPosition.y,
          distance: this.input.locationInfo.distance,
          driveTime: this.input.locationInfo.driveTime,
        }
        this.$emit("locationInfo", this.locationInfoData);
      },
      async showDefaultList(bind) {
        if(bind.searchKeyword != null && bind.searchKeyword.length>0) {
          return;
        }
        let homeAddrList = [];
        let recentAddrList = [];

        //집주소 불러오기
        if(Object.keys(this.customerInfo).length > 0) {
          const customerInfo = this.customerInfo;
          if(customerInfo.addressLat !== 0 && customerInfo.addressLng !== 0) {
            const addrArr = customerInfo.address.split('(');
            homeAddrList.push({
              address_name:addrArr[0],
              place_name:addrArr[addrArr.length-1].replace(')',''),
              x:customerInfo.addressLng,
              y:customerInfo.addressLat
            });
          } else {
            const customerAddress = await this.searchCustomerAddress(customerInfo.address)
            if (customerAddress) {
              homeAddrList.push(customerAddress)
            }
          }

          //최근 배송목록 불러오기
          const recentList = await this.$api.getRecentList(customerInfo.id);
          for(let idx in recentList.data) {
            const item = recentList.data[idx];
            let {address, place, x, y} = item;
            recentAddrList.push({
              place_name : place,
              address_name : address,
              x : x,
              y : y,
            });
           }

          if(homeAddrList.length>0 || recentAddrList.length>0 ) {
            bind.showList = true;
            bind.isDefault = true;
            bind.homeAddressList = homeAddrList;
            bind.recentAddressList = recentAddrList;
          }
        }
      },
      fieldClean(bind) {
        bind.searchKeyword = null;
      },
      clearData() {
        this.initData();
        this.initMapObject();
      }
    }
  }
</script>

<style scoped>
#delivery-map{
  width: 100%;height: 500px;
}
#delivery-short-info {
  position: absolute;
  top: 0;
  right: 0;
  width: 250px;
  height: 90px;
  background-color: rgba(0,0,0,0.5);
  z-index: 5;
}
</style>